import React, {useState, useEffect, useCallback} from 'react';
import styles from '../style.module.scss';
import {getLocalesByKey as t} from '@/utils/translation';
import {Checkbox} from 'antd';
import {ApplyBtnWrapper, ApplyButton, CustomRangeContainer, InputStyled, RadioStyled, TextBlack} from '../styledComponents';

interface Props {
  type?: string;
  filterId?: number;
  filterLabel?: string;
  filterName?: string;
  onChange?: (filter:any)=>void;
  className?: string;
  filterField?: string;
  customFields?: any[];
  headerField?: any;
  isDisable?:boolean;
  isClear?: boolean;
  onClear?: (data: any)=>void;
  absoluteUi?: boolean;
  isPageExplorer?: boolean;
  queryVal?: string;
}

const FilterKeywordPopUp: React.FC<Props> = ({type, queryVal, filterField, headerField, filterId, customFields, filterLabel, filterName, onChange, isPageExplorer}) => {
  const [value, setValue] = useState(headerField?.type || 'contains');
  const [operator, setOperator] = useState(headerField?.operator ||'contains');
  const [query, setQuery] = useState('');
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (type) {
      setValue(type);
      setOperator(type);
    }
  }, [type]);

  useEffect(() => {
    if (queryVal) {
      setQuery(queryVal);
    } else {
      setQuery('');
    }
  }, [queryVal]);

  const onChangeValue = useCallback(

    e => {
      if (headerField?.type == value) {
        setQuery('');
      }
      setValue(e.target.value);
    },
    [],
  );


  const createOrUpdateFilter = e =>{
    e.preventDefault();
    emitOnChanges(operator, query);
  };

  const emitOnChanges = (operator: string, query: string) => {
    if (typeof onChange === 'function') {
      onChange({
        id: filterId,
        header: filterLabel,
        name: filterName,
        type: value,
        operator: operator,
        query: query,
        filterField: filterField,
        active: true,
        customFields: customFields,
        checked: checked,
        isUrl: filterLabel == 'url' && isPageExplorer ? true : false,
      });
    }
  };

  const disablingButton = () =>{
    if (query=='') {
      return true;
    } else {
      return false;
    }
  };

  const filterPopupOptions = customFields?.length ? customFields : [
    {label: 'Contains', operator: 'contains'},
    {label: 'Doesn’t contain', operator: 'does_not_contain'},
    {label: 'Starts With', operator: 'starts_with'},
    {label: 'Ends With', operator: 'ends_with'},
  ];
  const checkBoxChange = () => {
    setChecked(!checked);
  };
  return (
    <CustomRangeContainer>
      {isPageExplorer && (filterLabel == 'title' || filterLabel == 'meta_description' ) ?<>
        <Checkbox checked={checked} onChange={checkBoxChange}>Case Insensitive Filtering </Checkbox>
        <hr color=' #E8E8E8'/></>: ''}
      <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
        {filterPopupOptions?.map(item=>{
          return (
            <div key={item.operator}>
              <RadioStyled
                value={item.operator}
                checked={value === item.operator}
                onChange={e=>[onChangeValue(e), setOperator(item.operator)]}
              ><TextBlack>{item.label}</TextBlack></RadioStyled>
              {value === item.operator && (
                <div className={styles.filterPopupOptionsOther}>
                  <InputStyled
                    value={query}
                    onChange={e=> {
                      if (!e.target.value) {
                        setQuery('');
                        return;
                      }
                      if (item?.inputType === 'number') {
                        const inputValue = Number(e.target.value);
                        if (item?.min !== null && (Number(inputValue) < item?.min)) {
                          setQuery('');
                          return;
                        } else if (item?.max !== null && (Number(inputValue) > item?.max)) {
                          setQuery('');
                          return;
                        } else {
                          setQuery(String(inputValue));
                        }
                      } else {
                        setQuery(e.target.value);
                      }
                    }}
                    type={item?.inputType || ''}
                    {...(item?.min !== null ? {min: item.min} : {})}
                    {...(item?.max !== null ? {max: item.max} : {})}
                  />
                </div>
              )}
            </div>

          );
        }) }
      </div>
      <ApplyBtnWrapper>
        <ApplyButton
          disabled={disablingButton()}
          onClick={createOrUpdateFilter}
        >
          {t('apply-filter')}
        </ApplyButton>
      </ApplyBtnWrapper>
    </CustomRangeContainer>
  );
};

export default FilterKeywordPopUp;
